export default __webpack_public_path__ + "static/media/bell-icon.ee2c1641.svg";